exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/** GT Theme PHP Framework Standard Definitions **/\n\n.visually-hidden {   /* Borrowed from Drupal */\n    position: absolute !important;\n    clip: rect(1px, 1px, 1px, 1px);\n    overflow: hidden;\n    height: 1px;\n    width: 1px;\n    word-wrap: normal;\n}\n\nDIV.region-header {\n  overflow: auto;\n}\n\nDIV.gt-page-body {\n  line-height: 1.5;\n  font-size: 110%;\n  font-weight: 300;\n  margin-bottom: 16px;\n}\n\nDIV.gt-page-body MAIN.main-content {\n  padding: 0 15px;\n}\n\nDIV.gt-page-body P {\n  margin: 10px 0;\n}\n\nDIV.gt-page-body INPUT,\nDIV.gt-page-body BUTTON,\nDIV.gt-page-body SELECT {\n  font-size: 90%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/imittal/Projects/angular_projects/my-adept/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/imittal/Projects/angular_projects/my-adept/node_modules/postcss-loader/lib?{"ident":"postcss"}!/Users/imittal/Projects/angular_projects/my-adept/src/app/css/gt3-php.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss"}!../../../../../src/app/css/gt3-php.css
// module chunks = styles